const translations = {
    day: '{{value}} day',
    days: '{{value}} days',
    footnote:
        'Restrictions are resolved per field across every label scenario applicable to this crop and state, including scenarios that apply in all states. The resolved set is conservative and may not correspond to a single scenario on the label; the governing scenario is recorded for each value.',
    governingProduct: 'Governing product',
    hour: '{{value}} hour',
    hours: '{{value}} hours',
    labelRestrictions: 'Label Restrictions',
    mostRestrictive: 'Most restrictive value across all products in the tank mix.',
    mostRestrictiveForCropInState:
        'Most restrictive value across all products in the tank mix for {{cropName}} in {{state}}.',
    noRestrictionsOnFile: 'No label restrictions on file for this commodity and state.',
    notStated: 'Not specified on label',
    preHarvestInterval: 'Pre-harvest interval',
    reEntryInterval: 'Re-entry interval',
    restriction: 'Restriction',
    sourceScenario: 'Source scenario',
    unquantifiable: 'Not quantifiable - see label',
    value: 'Value'
};

export default translations;
